module.exports = __webpack_public_path__ + "static/asx_logo_black-734e892a7bc41e7a7d9ff69eb7c3581a.png";